// Permission keys of the admin panel (the catalog lives in dm-admin-backend: src/modules/iam/permission/permission-catalog.ts).
// A key is "<page>.<action>": customer.view, coupon.edit, order.refund ... The panel hides what the role may not use;
// the API checks the same keys.

// pages that are part of another page's permission (their own page is not in the catalog)
const PAGE_ALIAS = {
  "customer-account-ledger": "customer",
  "vendor-account-ledger": "vendor",
  "loan-party-ledger": "loan-party",
  "loan-disburse": "loan-transaction",
  "loan-repayment": "loan-transaction",
  "sms-history": "send-sms",
  "email-history": "send-email",
};

/** pageKey("coupon", "edit") -> "coupon.edit" */
export const pageKey = (slug, action) => `${PAGE_ALIAS[slug] || slug}.${action}`;

/** The permission of an Order menu list: orderSectionKey("") -> "order-list.all", ("purchasing") -> "order-list.purchasing" */
export const orderSectionKey = (slug) => `order-list.${slug || "all"}`;

/** The permission of a business report page */
export const reportKey = (slug) => `report.${slug}`;

// the order row actions (orderListActions.js) and the permission each one needs
export const ORDER_ACTION_PERMISSION = {
  initiatePurchase: "order.purchase-initiate",
  completePurchase: "order.purchase-complete",
  tracking: "order.tracking-update",
  sorting: "order.sorting-update",
  delivery: "order.delivery-update",
  orderComplete: "order.payment",
  printInvoice: "order.invoice",
  cancelOrder: "order.cancel",
};
